const connection = io.connect(`${location.protocol}//${location.hostname}:4010/`);

connection.on('connect', () => {
	connection.emit('realtime:join');
});

module.exports = {
	connection
}
